export enum WizardSteps {
  description = 'description',
  accountSelection = 'accountSelection',
  success = 'success',
}
